module.exports = __webpack_public_path__ + "static/media/NEW.8551e2db.svg";